"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderHtml = void 0;
var React = require("react");
exports.RenderHtml = function (props) {
    var html = { __html: props.html };
    return React.createElement("span", { dangerouslySetInnerHTML: html, className: props.className });
};
//# sourceMappingURL=render-html.comp.js.map